// extracted by css-extract-rspack-plugin
export default {"followSearchText":"_e1f09480","searchName":"_f23132ab"};